import app from '$$app';
import constants from './constants';

const innerObject = {
  debug: (window.location.host !== 'app.ganttpro.com'),
  setup: {},
  open(setup) {
    if (window.Calendly) {
      innerObject.setup = setup;
      innerObject.setup.source = window.location.host;
      let userJobTitleTranslated = '';
      let userTeamSizeTranslated = '';

      constants.JOB_TITLES.map(obj => {
        if (Object.keys(obj)[0] === `${user.settings.user_job_title}`) {
          userJobTitleTranslated = __(obj[Object.keys(obj)[0]]);
        }
      });
      constants.TEAM_SIZES.map(obj => {
        // console.log(Object.keys(obj)[0], user.settings.user_team, __(obj[Object.keys(obj)[0]]))
        if (Object.keys(obj)[0] === `${user.settings.user_team}`) {
          userTeamSizeTranslated = __(obj[Object.keys(obj)[0]]);
        }
      });
      // ?utm-source=email&utm_campaign=d1

      const calendlyConfig = {
        url: window.user.locale === 'ru'
          ? 'https://calendly.com/d/4sv-h8t-4b4/meet-with-me'
          : 'https://calendly.com/d/2wz-pqc-m8y/schedule-a-meeting',
        utm: {
          utmCampaign: innerObject.setup.campaign,
          utmSource: innerObject.setup.source,
          // utmMedium: "Ad",
          // utmContent: "Shoe and Shirts",
          // utmTerm: "Spring"
        },
        prefill: {
          name: `${user.firstName} ${user.lastName}`,
          email: `${user.email}`,
          phone: `${user.settings.user_phone || ''}`,
          customAnswers: {
            a1: user.settings.user_company,
            a2: userTeamSizeTranslated,
            a3: userJobTitleTranslated,
            // a3: `${user.settings.user_phone || ''}`,
            a4: '', // Что бы вы хотели обсудить на звонке? (оставить пустым)
            // a5: '', // Каким инструментом вы пользуетесь сейчас? (оставить пустым)
            // a6: userTeamSizeTranslated,
          },
        },
      };

      window.Calendly.initPopupWidget(calendlyConfig);
      
      // кастомные стили для кнопки закрытия попапа
      const applyCloseButtonStyles = () => {
        const closeButton = document.querySelector('.calendly-popup-close');
        if (closeButton) {
          // Находим calendly-popup-content (контейнер контента попапа, относительно которого позиционируем кнопку)
          // calendly-popup-close и calendly-popup являются siblings внутри calendly-overlay
          const popupContent = closeButton.parentElement?.querySelector('.calendly-popup-content') ||
                               document.querySelector('.calendly-popup-content');
          
          if (!popupContent) {
            return false;
          }
          
          // Перемещаем кнопку закрытия внутрь calendly-popup-content, если она там еще не находится
          if (!popupContent.contains(closeButton)) {
            popupContent.appendChild(closeButton);
          }
          
          // Убеждаемся, что calendly-popup-content имеет position: relative для правильного позиционирования
          const popupContentStyle = window.getComputedStyle(popupContent);
          if (popupContentStyle.position === 'static' || popupContentStyle.position === '') {
            popupContent.style.position = 'relative';
          }
          
          // Скрываем стандартную иконку
          const svg = closeButton.querySelector('svg');
          if (svg) {
            svg.style.display = 'none';
            svg.style.visibility = 'hidden';
            svg.style.opacity = '0';
          }
          
          // Применяем кастомный SVG
          const svgDataUrl = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'%3E%3Crect width='32' height='32' rx='16' fill='%23505960'/%3E%3Cpath d='M21.2593 23.1155C21.7719 23.6281 22.603 23.6281 23.1156 23.1155C23.6281 22.6029 23.6281 21.7719 23.1156 21.2593L17.8563 16L23.1156 10.7407C23.6281 10.2281 23.6281 9.39706 23.1156 8.88448C22.603 8.37189 21.7719 8.37189 21.2593 8.88448L16 14.1438L10.7407 8.88444C10.2281 8.37185 9.39702 8.37185 8.88444 8.88444C8.37185 9.39702 8.37186 10.2281 8.88444 10.7407L14.1438 16L8.88444 21.2593C8.37185 21.7719 8.37185 22.603 8.88444 23.1156C9.39702 23.6281 10.2281 23.6281 10.7407 23.1156L16 17.8562L21.2593 23.1155Z' fill='white'/%3E%3C/svg%3E";
          
          
          closeButton.style.cssText = `
            width: 32px !important;
            height: 32px !important;
            min-width: 32px !important;
            min-height: 32px !important;
            display: block !important;
            position: absolute !important;
            top: 30px !important;
            right: 60px !important;
            background-image: url("${svgDataUrl}") !important;
            background-size: 32px 32px !important;
            background-repeat: no-repeat !important;
            background-position: center center !important;
            background-color: transparent !important;
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
            box-sizing: border-box !important;
            cursor: pointer !important;
            opacity: 1 !important;
            visibility: visible !important;
            z-index: 1000 !important;
          `;
          
          return true;
        }
        return false;
      };
      
      
      if (!applyCloseButtonStyles()) {
        const intervalId = setInterval(() => {
          if (applyCloseButtonStyles()) {
            clearInterval(intervalId);
          }
        }, 50);
        
        setTimeout(() => clearInterval(intervalId), 2000);
      }
      // console.log('calendlyConfig ==> ', calendlyConfig.parentElement);
    }
  },
  isCalendlyEvent(e) {
    return e.data.event && e.data.event.indexOf('calendly') === 0;
  },
};

window.addEventListener('message', e => {
  // console.log(e)
  if (innerObject.isCalendlyEvent(e)) {
    userExtAnalytics.log(e.data.event, innerObject.setup);
  }
});

// open demo popup immidiately if url contains "democampaign"
// mostly we do this for demo scheduling from emails
// example https://app.ganttpro.com/?democampaign=appFirstEmailInlineLink
// Replace setImmediate with setTimeout
setTimeout(() => {
  app.on('app:initModels', () => {
    const URLKEY = 'democampaign';
    const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has(URLKEY)) {
        innerObject.open({
        });
      }
    });
  // Delay of 10 ms to mimic setImmediate
  }, 10);

export default innerObject;
